import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-common/printer";
import { productIdFormat } from "@redotech/redo-ids/ids";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const renderBarcodeLabelTemplate = {
  name: "renderBarcodeLabelTemplate" as const,
  input: z.object({
    templateId: zExt.objectId(),
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        copies: z.number().int().nonnegative(),
      }),
    ),
    printerId: z.number().optional(),
    printerOptions: PrinterOptionsSchema.optional(),
    idempotencyKey: z.string().optional(),
  }),
  output: z.object({
    pdfBase64: z.string(),
    printedToWorkstation: z.boolean().optional(),
  }),
};
